import { withAuthenticationRequired } from "@auth0/auth0-react";
import Providers from "@/components/providers";
import RouterProvider from "@/components/providers/route-provider";

function App() {
  return (
    <Providers>
      <RouterProvider />
    </Providers>
  );
}

export default withAuthenticationRequired(App);
